export function ConvertDates() {
    return {
        timestampToDate,
        dateComparison
    }
}

function timestampToDate(date) {
    const day = new Date(date * 1000)
    const times = day.toLocaleDateString('es-ES')
    return times
}

function dateComparison(date) {
    const firstDate = new Date(date * 1000)
    const secondDate = new Date("2999-12-31")
    if (firstDate.getTime() > secondDate.getTime()) {
        return "Lifetime"
    }
    if (firstDate.getTime() < secondDate.getTime()) {
        return timestampToDate(date)
    }
    return "Invalid date"
}